import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';

import validate from 'validate.js';
import { useTranslation } from 'react-i18next';
import { AddPostParentCommentApi } from 'utils/clientApis';
import { makeStyles, useTheme } from '@material-ui/styles';
import {
  Avatar,
  Box,
  Button,
  Divider,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CloseIcon from '@material-ui/icons/Close';

const schema = {
  comment: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 500,
      minimum: 3
    }
  }
};

export default function NoticeBoard({
  openNotice,
  noticeData,
  notiCommentData,
  handleClose,
  postId
}) {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [commentState, setCommentState] = useState({
    data: {
      contents: ''
    },
    errors: {},
    touched: {},
    isValid: false
  });

  useEffect(() => {
    const errors = validate(commentState.data, schema);
    setCommentState(prevState => ({
      ...prevState,
      isValid: !errors,
      errors: errors || {}
    }));
  }, [commentState.data, schema]);

  // 공지글 코멘트 생성 핸들러
  const handlePostNotiComment = async () => {
    try {
      if (noticeData) {
        const response = await AddPostParentCommentApi(
          postId,
          commentState.data
        );
        if (response) {
          setCommentState({
            data: {
              contents: ''
            }
          });
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleCommentChange = event => {
    event.persist();
    const { name, value } = event.target;

    setCommentState(prevState => ({
      ...prevState,
      data: {
        ...prevState.data,
        [name]: value
      },
      touched: {
        ...prevState.touched,
        [name]: true
      }
    }));
  };

  return (
    <>
      <Dialog
        open={openNotice}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // onClose={handleClose}
        fullWidth
        maxWidth="md"
        fullScreen={fullScreen}
        scroll="body">
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: 'white',
              zIndex: '999',
              width: '100%',
              padding: '0px 8px',
              marginLeft: '-8px'
            }}>
            <DialogTitle text="h6">
              <Typography color="primary" style={{ fontWeight: '700' }}>
                공지사항
              </Typography>
            </DialogTitle>
            <CloseIcon
              onClick={() => handleClose()}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <Divider />
          <div className={classes.whiteLine} />
          <DialogContent
            alt="post"
            style={{ padding: '24px 24px', marginBottom: '24px' }}>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: '16px'
              }}>
              <Avatar
                src={'/images/logo_duck.png'}
                variant="circle"
                style={{
                  width: '40px',
                  height: '40px',
                  marginRight: '8px'
                }}
              />
              <Typography color="primary" style={{ fontWeight: '700' }}>
                라이덕
              </Typography>
            </Box>
            {noticeData && (
              <DialogContentText id="alert-dialog-description">
                <Typography variant="h4">{noticeData[0].title}</Typography>
                <Box style={{ padding: '8px 0px' }}>
                  <Typography variant="body1" color="textPrimary">
                    {noticeData[0].content
                      ?.split('\n')
                      .map((paragraph, index) => (
                        <React.Fragment key={index}>
                          {paragraph}
                          <br />
                        </React.Fragment>
                      ))}
                  </Typography>
                </Box>
              </DialogContentText>
            )}
          </DialogContent>
          <Divider />
          {notiCommentData &&
            notiCommentData.map((comment, idx) => {
              return (
                <DialogContent
                  alt="comment"
                  style={{ padding: '16px 24px' }}
                  key={idx}>
                  <DialogContentText
                    id="alert-dialog-description"
                    text="body1"
                    color="textPrimary">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                      }}>
                      <Avatar
                        src={comment.commentUserProfileImage}
                        variant="circle"
                        style={{
                          width: '28px',
                          height: '28px',
                          marginRight: '8px'
                        }}
                      />
                      <Typography variant="h6">
                        {comment.commentUserDisplayName}
                      </Typography>
                    </div>
                    <Typography
                      variant="body1"
                      key={comment.id}
                      style={{ padding: '0px 36px' }}>
                      {comment.contents?.split('\n').map((paragraph, index) => (
                        <React.Fragment key={index}>
                          {paragraph}
                          <br />
                        </React.Fragment>
                      ))}
                    </Typography>
                  </DialogContentText>
                </DialogContent>
              );
            })}
          <DialogContent
            alt="writeComment"
            style={{ padding: '16px 16px', marginBottom: '16px' }}>
            <TextField
              fullWidth
              label={'댓글 작성'}
              name="contents"
              type="text"
              multiline
              rows={3}
              onChange={handleCommentChange}
              value={commentState.data.contents}
              variant="outlined"
            />
            <DialogActions>
              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={handlePostNotiComment}>
                댓글 등록
              </Button>
            </DialogActions>
          </DialogContent>
        </>
      </Dialog>
    </>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  topBar: {
    paddingBottom: '8px',
    borderBottom: '1px #dddddd solid',
    display: 'flex',
    alignItems: 'center'
  },
  whiteLine: {
    borderBottom: '1px #ffffff solid',
    marginBottom: '16px'
  },
  canvasHead: {
    padding: '16px 16px',
    backgroundColor: 'white',
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
    borderRadius: '4px 4px 0 0',
    [theme.breakpoints.down('md')]: {
      padding: '8px 8px'
    }
  },
  canvasBody: {
    padding: '16px 16px',
    backgroundColor: 'white',
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
    borderRadius: '0 0 4px 4px',
    [theme.breakpoints.down('md')]: {
      padding: '8px 8px'
    }
  },
  title: {
    fontSize: '14px',
    color: '#73838b',
    lineHeight: '28px',
    padding: '0px',
    [theme.breakpoints.up('md')]: {
      fontSize: '16px'
    }
  },
  menu: {
    fontSize: '14px',
    color: '#455A64',
    fontWeight: '700',
    padding: '0px',
    [theme.breakpoints.up('md')]: {
      fontSize: '14px'
    }
  },
  chipWrap: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: '16px',
    '& .MuiChip-root': {
      '&.Mui-disabled': {
        backgroundColor: theme.palette.action.disabledBackground,
        color: theme.palette.action.disabled
      }
    },
    '& > *': {
      marginRight: '4px'
    }
  },
  card: {
    height: '100%'
  },
  searchWrap: {
    width: '100%',
    display: 'flex',
    justifyContent: 'end'
  },
  banner: {
    /*#4db6ac*/
    backgroundColor: 'lightblue',
    border: '1px #dddddd solid',
    height: '120px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px',

    backgroundImage: "url('/images/peloton_notice.png')",
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left 85%',
    backgroundSize: 'cover'
  },
  textField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      width: '300px',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  image: {
    height: '193px',
    width: '100%',
    objectFit: 'cover'
  }
}));
